import { useQuery } from '@tanstack/react-query';
import { PAGE_QUERIES } from '../../infrastructure/page/utils/queries';
import type { GetPageMetaRequest } from '../../infrastructure/page/utils/types';

export const usePageService = () => {
  const useGetPageMeta = (params: GetPageMetaRequest, options?: { enabled?: boolean }) => {
    return useQuery({
      ...PAGE_QUERIES.getPageMeta(params),
      enabled: options?.enabled !== undefined ? options.enabled : Boolean(params.pathname),
    });
  };

  return {
    useGetPageMeta,
  };
};
